import styled from '@emotion/styled';
import { push } from 'connected-react-router';
import React from 'react';
import { useDispatch } from 'react-redux';
import CustomerDisplayFooter from '../../components/CustomerDisplayFooter';
import DisplayedOrdersList from '../../components/DisplayedOrdersList';
import { useCustomCSS } from '../../hooks/useCustomCSS';
import { Routes } from '../../routes.types';

const Container = styled.div`
    width: 100%;
    height: 100vh;
    background-color: ${({ theme }) => theme.color.black};
    display: flex;
    flex-direction: column;
`;

const CustomerDisplay: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    useCustomCSS();

    const returnToHome = () => {
        dispatch(push(Routes.Home));
    };

    return (
        <Container id="ods-page-wrapper" data-testid="ods-container" onClick={returnToHome}>
            <DisplayedOrdersList />
            <CustomerDisplayFooter />
        </Container>
    );
};

export default CustomerDisplay;
